import color from "@constants/color";
import t from "@constants/localization";
import React from "react";
import { Animated, StyleSheet, Text, View } from "react-native";

const PATH = "screens/RatingInfo";

const RatingCard = ({ summary }) => {
  const colorSelector = (rating) => {
    const ratingDigit = Number(rating).toFixed(1);
    if (ratingDigit > 2.9) {
      return color.plain_green;
    } else if (ratingDigit > 1.9) {
      return color.orange;
    } else {
      return color.plain_red;
    }
  };
  return (
    <View style={styles.ratingContainer}>
      <View style={styles.heading}>
        <Text style={styles.sectionTitle}>{summary.header_text}</Text>
      </View>

      <View style={styles.overAllRating}>
        <View style={{ flex: 0.45 }}>
          <Text style={styles.ratingText}>
            <Text bold style={styles.overallRatingText}>
              {summary?.overall_rating || 0}
            </Text>
            /5
          </Text>
          <Text
            style={[
              styles.ratingCount,
              { color: color.lightBlack, fontWeight: "500" },
            ]}
          >
            {summary?.number_of_ratings < 1000
              ? summary?.number_of_ratings
              : `${(summary?.number_of_ratings / 1000).toFixed(1)}k` || 0}
            {` `}
            {t(`${PATH}/rating`)}
          </Text>
        </View>
        <View style={styles.horizontalSeparator} />
        <View style={styles.ratingsContainer}>
          {summary?.ratings?.map((item, idx, arr) => (
            <View key={item} style={styles.singleRatingContainer}>
              <Text style={styles.ratingCount}>
                {arr.length - idx} {t(`${PATH}/star`)}
              </Text>
              <View style={styles.progressBar}>
                <Animated.View
                  style={
                    ([StyleSheet.absoluteFill],
                    {
                      backgroundColor: colorSelector(arr.length - idx),
                      width: `${(item / summary?.number_of_ratings) * 100}%`,
                      borderRadius: 10,
                    })
                  }
                />
              </View>
              <Text style={styles.ratingCount}>{item}</Text>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};

export default RatingCard;

const styles = StyleSheet.create({
  ratingContainer: {
    backgroundColor: "#F6F8FA",
    marginVertical: 8,
    borderRadius: 16,
  },
  heading: {
    paddingTop: 12,
    paddingLeft: 12,
  },
  overallRatingText: {
    fontSize: 36,
    fontWeight: "700",
  },
  ratingCount: {
    fontSize: 12,
    color: color.lightMediumBlack,
    fontWeight: "400",
    textAlign: "center",
  },
  progressBar: {
    flexDirection: "row",
    height: 7,
    width: "55%",
    backgroundColor: color.lighterBlack,
    borderRadius: 14,
    marginHorizontal: 8,
    alignSelf: "center",
    overflow: "hidden",
  },
  horizontalSeparator: {
    height: "75%",
    width: 1,
    backgroundColor: color.lighterBlack,
    marginRight: "5%",
  },
  overAllRating: {
    alignItems: "center",
    flexDirection: "row",
    paddingBottom: 16,
  },
  ratingText: {
    fontSize: 16,
    color: color.mediumBlack,
    fontWeight: "500",
    textAlign: "center",
  },
  ratingsContainer: {
    alignItems: "flex-start",
    flex: 0.5,
  },
  singleRatingContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 4,
  },
  sectionTitle: {
    fontSize: 16,
    color: color.mediumBlack,
    fontWeight: "700",
  },
});
